import { Table, TableCell, TableContainer, TableRow } from "@mui/material";
import { ReadOnlyWrapper } from "components/common/ReadOnlyWrapper";
import React from "react";
import styled, { css } from "styled-components";
import { Background, Border, Main, Text } from "styles/themeColors";
import Icon from "view/Icon";

const ButtonIcon = styled(Icon).attrs({ size: 24 }) <any>`
    button {
        padding: 0px !important;
    }
    path {
        ${({ fillColor }) => fillColor && css`
            fill: ${fillColor};
        `}
    }
`;

interface Props {
    handleDelete?: Function;
    selectedRows: number[];
    headers?: any[];
    readOnly?: boolean;
    hideDeleteBtn?: boolean;
}

const TableHeader = ({ handleDelete, selectedRows, headers = [], readOnly, hideDeleteBtn = false }: Props) => {
    return (
        <TableContainer style={{ border: `1px solid ${Border.light}`, borderTopLeftRadius: 12, borderTopRightRadius: 12, borderBottomWidth: 0 }}>
            <Table>
                <TableRow style={{ backgroundColor: Background.light, fontSize: 16, padding: 0 }}>
                    {
                        !hideDeleteBtn &&
                        <TableCell
                            align="left"
                            style={{ backgroundColor: Background.light, fontSize: 16, padding: '12px 9px', borderWidth: 0 }}
                        >

                            <ReadOnlyWrapper readOnly={readOnly}>
                                <ButtonIcon
                                    name='DeleteVariants'
                                    onClick={readOnly ? undefined : handleDelete}
                                    fillColor={selectedRows.length > 0 ? Main.error2 : Text.secondary}
                                />
                            </ReadOnlyWrapper>

                        </TableCell>
                    }
                    {
                        headers.map((group, index) => (
                            <TableCell
                                key={group.category}
                                align="center"
                                colSpan={group.columns.length}
                                style={{
                                    backgroundColor: Background.light,
                                    fontSize: 16,
                                    padding: 0,
                                }}
                            >
                                {group.category}
                            </TableCell>
                        ))
                    }
                </TableRow>
            </Table>
        </TableContainer>
    );
}

export default TableHeader;